<template>
  <div>
    <el-dialog title="审核" :visible.sync="auditDialog" width="60%" @closed="handleClose" :modal-append-to-body="false">
      <div class="log-container">
        <div v-if="beforeUpdate.id" class="before-update">
          <h3>修改前</h3>
          <el-form :model.sync="beforeUpdate" label-width="120px">
            <el-form-item label="会员类别">
              {{ beforeUpdate.type }}
            </el-form-item>
            <el-form-item label="会员等级">
              {{ beforeUpdate.level }}
            </el-form-item>
            <el-form-item label="权重等级">
              {{ beforeUpdate.weightLevel }}
            </el-form-item>
            <el-form-item label="售卖状态">
              {{ beforeUpdate.sellStatus }}
            </el-form-item>
            <el-form-item label="用户身份">
              {{ beforeUpdate.memberIdentity }}
            </el-form-item>
            <el-form-item label="会员类别名称">
              {{ beforeUpdate.name }}
            </el-form-item>
            <el-form-item v-if="beforeUpdate.sceneFlag" label="展示场景">
              {{ beforeUpdate.sceneFlag }}
            </el-form-item>
            <el-form-item label="会员图标">
              <el-image v-if="beforeUpdate.icon" style="width: 80px;height: 80px;" :src="beforeUpdate.icon"
                fit="scale - down"></el-image>
              <span v-else>暂无图标</span>
            </el-form-item>
            <el-form-item label="类型描述">
              {{ beforeUpdate.description }}
            </el-form-item>
            <el-form-item label="刊例价格">
              {{ beforeUpdate.publishPrice }}
            </el-form-item>
            <el-form-item label="客户端类型">
              <div v-for="item in beforeUpdate.clientTypes" :key="item"> {{ item }}</div>
            </el-form-item>
            <el-form-item label="权益项集">
              <span v-for="(item, index) in beforeUpdate.memberRights" :key="item">{{ item }}{{ index + 1 ===
                afterUpdate.memberRights.length ? '' : '，' }}</span>
            </el-form-item>
            <el-form-item label="限制参数">
              <div v-for="item in beforeUpdate.limitParams" :key="item">
                <span style="margin-right: 20px;">{{ item.rightsName }}</span><span
                  v-for="(ele, index) in item.limitParams" :key="ele">{{ ele.limitParamName }}{{ ele.limitParamVal ? '-' +
                    ele.limitParamVal +
                    '分钟' : '' }}{{ index + 1 === item.limitParams.length ? "" : '，' }}</span>
              </div>
            </el-form-item>
            <el-form-item label="类型状态">
              {{ beforeUpdate.state }}
            </el-form-item>
            <el-form-item label="备注">
              {{ beforeUpdate.remark }}
            </el-form-item>
          </el-form>
        </div>
        <div class="after-update">
          <h3>修改后</h3>
          <el-form :model.sync="afterUpdate" label-width="120px">
            <el-form-item label="会员类别">
              {{ afterUpdate.type }}
            </el-form-item>
            <el-form-item label="会员等级">
              {{ afterUpdate.level }}
            </el-form-item>
            <el-form-item label="权重等级">
              {{ afterUpdate.weightLevel }}
            </el-form-item>
            <el-form-item label="售卖状态">
              {{ afterUpdate.sellStatus }}
            </el-form-item>
            <el-form-item label="用户身份">
              {{ afterUpdate.memberIdentity }}
            </el-form-item>
            <el-form-item label="会员类别名称">
              {{ afterUpdate.name }}
            </el-form-item>
            <el-form-item v-if="afterUpdate.sceneFlag" label="展示场景">
              {{ afterUpdate.sceneFlag }}
            </el-form-item>
            <el-form-item label="会员图标">
              <el-image v-if="afterUpdate.icon" style="width: 80px;height: 80px;" :src="afterUpdate.icon"
                fit="scale - down"></el-image>
              <span v-else>暂无图标</span>
            </el-form-item>
            <el-form-item label="类型描述">
              {{ afterUpdate.description }}
            </el-form-item>
            <el-form-item label="刊例价格">
              {{ afterUpdate.publishPrice }}
            </el-form-item>
            <el-form-item label="客户端类型">
              <div v-for="item in afterUpdate.clientTypes" :key="item"> {{ item }}</div>
            </el-form-item>
            <el-form-item label="权益项集">
              <span v-for="(item, index) in afterUpdate.memberRights" :key="item">{{ item }}{{ index + 1 ===
                afterUpdate.memberRights.length ? '' : '，' }}</span>
              <!-- <div v-for="item in afterUpdate.memberRights" :key="item">{{ item }}</div> -->
            </el-form-item>
            <el-form-item label="限制参数">
              <div v-for="item in afterUpdate.limitParams" :key="item">
                <span style="margin-right: 20px;">{{ item.rightsName }}</span><span
                  v-for="(ele, index) in item.limitParams" :key="ele">{{ ele.limitParamName }}{{ ele.limitParamVal ? '-' +
                    ele.limitParamVal +
                    '分钟' : '' }}{{ index + 1 === item.limitParams.length ? "" : '，' }}</span>
              </div>
            </el-form-item>
            <el-form-item label="类型状态">
              {{ afterUpdate.state }}
            </el-form-item>
            <el-form-item label="备注">
              {{ afterUpdate.remark }}
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 确认提交审核按钮 -->
      <div v-if="!showAuditOpinion" class="dialog-footer">
        <el-button type="primary" @click="handleSubmitAudit">确认提交审核</el-button>
      </div>
      <!-- 审核意见 -->
      <div v-if="showAuditOpinion">
        <div class="dialog-footer">
          <el-button @click="submitReject">审核不通过</el-button>
          <el-button type="primary" @click="submitPASS">审核通过</el-button>
        </div>
        <div class="dialog-footer">
          <el-input style="width: 60%;" type="textarea" show-word-limit :autosize="{ minRows: 2, maxRows: 10 }"
            maxlength="999" placeholder="审核意见" v-model="auditOpinion"></el-input>
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import Message from "@/components/Message";
import { submitAudit, passMemberTypeLocal, rejectMemberTypeLocal } from '@/api/memberNew/memberType'
export default {
  props: {
    /** 对话框的显隐 */
    auditDialog: {
      type: Boolean,
      default: false,
    },
    /** 审核意见的显隐 */
    showAuditOpinion: {
      type: Boolean,
      default: false,
    },
    /** 修改前的数据 */
    beforeUpdate: {
      type: Object,
      default: () => {
        return {
          type: '',
          level: '',
          weightLevel: '',
          sellStatus: '',
          memberIdentity: '',
          name: '',
          sceneFlag: '',
          icon: '',
          description: '',
          publishPrice: '',
          clientTypes: '',
          memberRights: '',
          limitParams: '',
          state: '',
          remark: '',
        };
      },
    },
    /** 修改后的数据 */
    afterUpdate: {
      type: Object,
      default: () => {
        return {
          type: '',
          level: '',
          weightLevel: '',
          sellStatus: '',
          name: '',
          icon: '',
          description: '',
          price: '',
          client_types: '',
          member_rights_item: '',
          limit_params: '',
          front_visible: '',
          state: '',
          remark: '',

        };
      },
    },

  },
  data() {
    return {
      /** 审核意见 */
      auditOpinion: '',
    };
  },



  methods: {
    /** 对话框关闭 */
    handleClose() {
      /** 清理数据 */
      this.auditOpinion = '';
      this.beforeUpdate = {},
      this.afterUpdate = {},
        this.$emit('update:auditDialog', false);
      this.$emit('update:showAuditOpinion', false);
    },
    /** 确认提交审核 */
    async handleSubmitAudit() {

      console.log("提交审核事件传递给接口的id", this.afterUpdate.id);
      /** 调用接口 */
      const { data } = await submitAudit(this.afterUpdate.id);
      console.log("确认提交审核接口的响应", data);
      /** 如果成功 提示用户 */
      /** 如果成功提示用户 */
      if (data.code === 200) {
        Message.success("提交审核成功");
        /** 更新数据 */
        this.$emit('update:auditDialog', false);
        this.$emit('update:showAuditOpinion', false);
        this.$emit("updateData");
      } else {
        Message.error("提交审核失败");
        this.$emit('update:auditDialog', false);
        this.$emit('update:showAuditOpinion', false);
        this.$emit("updateData");
      }
    },
    /** 审核通过事件 */
    async submitPASS() {
      /** 调用接口 */
      const { data } = await passMemberTypeLocal({
        id: this.afterUpdate.id,
        auditOpinion: this.auditOpinion
      });
      /** 如果成功则提示用户 */
      if (data.code === 200) {
        this.$emit("update:auditDialog", false);
        this.$emit("update:showAuditOpinion", false);
        this.$emit("updateData");
        Message.success("操作成功");
      } else {
        Message.error("操作失败");
      }
    },
    /** 审核拒绝事件 */
    async submitReject() {
      /** 调用接口 */
      const { data } = await rejectMemberTypeLocal({
        id: this.afterUpdate.id,
        auditOpinion: this.auditOpinion
      });
      /** 如果成功则提示用户 */
      if (data.code === 200) {
        this.$emit("update:auditDialog", false);
        this.$emit("update:showAuditOpinion", false);
        this.$emit("updateData");
        Message.success("操作成功");
      } else {
        Message.error("操作失败");
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.log-container {
  display: flex;

  .before-update {
    padding: 10px;
    flex: 1;
    background-color: #f2f2f2;
    /** 水平垂直居中 */
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
    margin-right: 20px;

    h3 {
      text-align: center;
    }
  }

  .after-update {
    padding: 10px;
    flex: 1;
    /** 水平垂直居中 */
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
    background-color: #f2f2f2;


    h3 {
      text-align: center;
    }
  }

  ::v-deep .el-form-item__label {
    /** 字体加粗 */
    font-weight: bold !important;
    text-align: left;
    font-size: 15px;
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>